import {Component} from '@angular/core';

@Component({
  selector: 'app-ppp-admin-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor() {
  }
}
